import AccountSettingsPage from "../account-settings/AccountSettingsPage";

const WorkerSettings = () => (
  <AccountSettingsPage
    showAgreement
    documentTitleKey="workerSettingsTitle"
    documentTitleDefault="Settings | Worker"
  />
);

export default WorkerSettings;
